/**
 * No-op shim for @sentry/electron/renderer in browser builds.
 * Aliased via vite.browser.config.mts resolve.alias.
 *
 * Only the Sentry APIs actually used in the renderer are shimmed explicitly;
 * the Proxy catch-all handles any other access gracefully.
 *
 * TODO: Replace with @sentry/browser for real browser error tracking.
 */
const noop = () => {}

export const init = noop
export const captureException = (error: unknown) => console.error('[sentry-shim]', error)
export const captureMessage = (msg: string) => console.warn('[sentry-shim]', msg)
export const addBreadcrumb = noop
export const setUser = noop
export const setTag = noop
export const setContext = noop
export const withScope = (cb: (scope: unknown) => void) => cb(new Proxy({}, { get: () => noop }))
export const BrowserTracing = class {}
export const Replay = class {}

const shim = new Proxy(
  {
    init,
    captureException,
    captureMessage,
    addBreadcrumb,
    setUser,
    setTag,
    setContext,
    withScope,
    BrowserTracing,
    Replay,
  } as Record<string, unknown>,
  { get: (target, prop) => (prop in target ? target[prop as string] : noop) },
)

export default shim
